import ChannelsService from 'data/ChannelsService';


class MockChannel {

  constructor(channelName, units) {
    this.channelName = channelName;
    this.channelsService = new ChannelsService.Factory().create();
    this.units = units;
    this.data = [];
    this.active = true;

    // Data generation parameters.
    this.min = 0 + Math.random() * 50;
    this.max = this.min + Math.random() * 200;
    this.value = (this.min + this.max) / 2;
    this.stepAmplitude = 1 + Math.random() * 2;
    this.stepWidthMillis = 500 + Math.random() * 2000;

    this.intervalId = setInterval(this.update.bind(this), this.stepWidthMillis);
  }

  getId() {
    return this.channelName;
  }

  getUnits() {
    return this.units;
  }

  getData() {
    return this.data;
  }

  getStatus() {
    return this.active ? 'Recording…' : 'Paused';
  }

  clearData() {
    this.data = [];
  }

  disconnect() {
    clearInterval(this.intervalId)
  }

  setActive(active) {
    this.active = active;
  }

  update() {
    const nowMillis = new Date();
    this.value = this.value - this.stepAmplitude * (2 * Math.random() - 1);
    if (this.value < this.min) this.value = 2 * this.min - this.value;
    if (this.value > this.max) this.value = 2 * this.max - this.value;

    if (!this.active) {
      return;
    }
    this.data.push({t: nowMillis, y: this.value});
    this.channelsService.update(this.getId(), nowMillis);
  }

}

export default MockChannel;

